// extracted by mini-css-extract-plugin
module.exports = {"translation":"Translation_translation__1OLUe","translate":"Translation_translate__1u84X","actions":"Translation_actions__1YB-t"};